import { quSave } from '@/service/question'
import iconSrc from '@/assets/images/edit/config/ico-title@2x.png'
export default {
  id: '',
  groupId: '',
  belongId: '',
  orderById: 40,
  elementType: 'TitleBox',
  elementDesc: '开放题',
  type: 'titlebox',
  // 是否可配置
  config: true,
  toolbar: {
    edit: true,
    delete: true,
    copy: true,
    config: false
  },
  title: '开放题',
  placeholder: '开放题',
  isRequired: '1',
  maxLength: 120,
  value: '',
  screenCode: '', // phone1 手机 email 邮箱  birthday生日 身份证 idCard
  // 表单name
  ruleError: '该字段不能为空',
  tipsMobileUnique: '该手机号已经答题,不能再次答题',
  tipsIDUnique: '该身份证号已经答题,不能再次答题',
  tipsPrefixUnique: '前${n}位手机号重复，请换一个新的号码',
  saveUrl: '/design/qu-fillblank/ajaxSave.do',
  iconStyle: {
    width: '12px',
    height: '12px',
    background: 'url(' + iconSrc + ')'
  },
  saveFn () {
    return quSave({
    }, this)
  },
  saveCb (data) {
    this.screenCode = data.screenCode
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      quId: this.id,
      answer: this.value
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/TitleBox/config.js